import {CommonModule, CurrencyPipe} from '@angular/common';
import {Component, Input} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {
  PoolHealthCheck,
  PoolWallet,
  PoolWalletBalance,
} from '@gatewee/types/pool';
import {HealthCheckStatus} from '@gatewee/types/health-check';
import {UtilsModule} from '@gatewee/utils';

@Component({
  selector: 'gatewee-pool-balance-view',
  standalone: true,
  imports: [CommonModule, TranslateModule, CurrencyPipe, UtilsModule],
  templateUrl: './gatewee-pool-balance-view.component.html',
  styleUrl: './gatewee-pool-balance-view.component.scss',
})
export class GateweePoolBalanceViewComponent {
  @Input({required: true}) healthCheck!: PoolHealthCheck;
  @Input() poolWallets?: PoolWallet[];
  @Input() loading = false;

  readonly healthCheckStatus = HealthCheckStatus;

  recipientName(wallet: PoolWalletBalance): string | undefined {
    if (wallet.recipient?.name) {
      return wallet.recipient.name;
    }
    return this.poolWalletById(wallet.walletId)?.recipient?.name;
  }

  walletLabel(wallet: PoolWalletBalance): string | undefined {
    if (wallet.label) {
      return wallet.label;
    }
    return this.poolWalletById(wallet.walletId)?.label;
  }

  private poolWalletById(walletId: number): PoolWallet | undefined {
    return this.poolWallets?.find(poolWallet => poolWallet.id === walletId);
  }

  get reconciliationClass(): string {
    if (!this.healthCheck.reconciliation) {
      return 'gw-text-gray-600 gw-bg-gray-100';
    }
    return this.healthCheck.reconciliation.isReconciled
      ? 'gw-text-green-600 gw-bg-green-100'
      : 'gw-text-red-600 gw-bg-red-100';
  }

  get providerStatusClass(): string {
    switch (this.healthCheck.providerStatus) {
      case HealthCheckStatus.PASSED:
        return 'gw-text-green-600 gw-bg-green-100';
      case HealthCheckStatus.FAILED:
        return 'gw-text-red-600 gw-bg-red-100';
      default:
        return 'gw-text-gray-600 gw-bg-gray-100';
    }
  }
}
